export default "__VITE_ASSET__Cn5yNuT7__"